import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  EymemoryChild,
  EymemoryLoginSessionStateType,
  EymemoryLoginStorageData,
  EymemoryNursery,
  EymemoryPersistLoginStateType,
  OrderDetails,
} from "src/shared/types/src";

const initalOrderData = {
  isLoggedIn: false,
  isAuthLoading: false,
  orderDetails: null,
  child: null,
  nursery: null,
};

const initialState: EymemoryLoginSessionStateType =
  {} as EymemoryLoginSessionStateType;

const persistState: EymemoryPersistLoginStateType =
  {} as EymemoryPersistLoginStateType;

const ensureOrderHashState = (
  state: EymemoryLoginSessionStateType,
  orderHash: string
) => {
  if (!state[orderHash] || !Object.keys(state[orderHash])?.length) {
    state[orderHash] = { ...initalOrderData };
  }
};

const eymemoryLoginSlice = createSlice({
  name: "eymemoryLoginSlice",
  initialState,
  reducers: {
    setIsLoggedIn: (
      state,
      action: PayloadAction<{ orderHash: string; isLoggedIn: boolean }>
    ) => {
      const { orderHash, isLoggedIn } = action.payload;
      ensureOrderHashState(state, orderHash);
      state[action.payload.orderHash].isLoggedIn = isLoggedIn;
    },
    setChild: (
      state,
      action: PayloadAction<{ orderHash: string; child: EymemoryChild }>
    ) => {
      const { orderHash, child } = action.payload;
      ensureOrderHashState(state, orderHash);
      state[action.payload.orderHash].child = child;
    },
    setNursery: (
      state,
      action: PayloadAction<{ orderHash: string; nursery: EymemoryNursery }>
    ) => {
      const { orderHash, nursery } = action.payload;
      ensureOrderHashState(state, orderHash);
      state[action.payload.orderHash].nursery = nursery;
    },
    setOrderDetails: (
      state,
      action: PayloadAction<{ orderHash: string; orderDetails: OrderDetails }>
    ) => {
      const { orderHash, orderDetails } = action.payload;
      ensureOrderHashState(state, orderHash);
      state[action.payload.orderHash].orderDetails = orderDetails;
    },
    setAuthLoading: (
      state,
      action: PayloadAction<{ orderHash: string; isAuthLoading: boolean }>
    ) => {
      const { orderHash, isAuthLoading } = action.payload;
      ensureOrderHashState(state, orderHash);
      state[action.payload.orderHash].isAuthLoading = isAuthLoading;
    },
    resetLoginState: (state, action: PayloadAction<{ orderHash?: string }>) => {
      if (action.payload.orderHash) {
        if (state[action.payload.orderHash]) {
          state[action.payload.orderHash] = { ...initalOrderData };
        }
      }
      else {
        Object.keys(state).forEach((key) => {
          state[key] = { ...initalOrderData };
        });
      }
    },
  },
});

const eymemoryPersistLoginSlice = createSlice({
  name: "eymemoryPersistLoginSlice",
  initialState: persistState,
  reducers: {
    setLoginData: (state, action: PayloadAction<EymemoryLoginStorageData>) => {
      const {orderHash} = action.payload;
      if(orderHash) {
        state[orderHash] = {loginData: action.payload};
      }
    },

    resetPersistLoginState: (
      state,
      action: PayloadAction<{ orderHash?: string }>
    ) => {
      const { orderHash } = action.payload;
    
      if (orderHash) {
        if (!state[orderHash]) {
          state[orderHash] = { loginData: null };
        } else {
          state[orderHash].loginData = null;
        }
      } else {
        Object.keys(state).forEach((key) => {
          state[key].loginData = null;
        });
      }
    }
  },
});

export const EymemoryLoginActions = eymemoryLoginSlice.actions;
export const EymemoryLoginPersistActions = eymemoryPersistLoginSlice.actions;
export const eymemoryLoginReducer = eymemoryLoginSlice.reducer;
export const eymemoryLoginPersistReducer = eymemoryPersistLoginSlice.reducer;
